import * as React from 'react'

type TOptions = {
  /**
   * id of the container holding the category elements
   */
  containerId: string
  /**
   * used as a dependency to recalculate the refListElements
   */
  dependencyData: any
}

/**
 * Returns a ref holding HTMLElements rendered inside a provided container.
 * Updates the ref whenever the data those elements depend on changes.
 */
export const useCategoryElements = ({ containerId, dependencyData }: TOptions) => {
  const refListElements = React.useRef<HTMLElement[]>([])

  React.useLayoutEffect(() => {
    const containerElement = document.getElementById(containerId)
    const listElements = Array.from(containerElement?.children ?? []) as HTMLElement[]

    refListElements.current = listElements
  }, [dependencyData, containerId])

  return refListElements
}
